<template>
  <div class="nuttrema-list-control">
    <div class="nav nav--nuttrema-list-control">
      <div class="nav-left">
        <slot name="left"></slot>
      </div>
      <div class="nav-center">
        <list-search
          :livesearch="liveSearch"
          :query="query"
          :localStorageKey="localStorageKey"
          @search="handleSearch"
          @clearSearch="handleClearSearch">
        </list-search>
      </div>
      <div class="nav-right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import ListSearch from 'components/ui/search/list-search';

export default {
  name: 'nuttrema-list-control',
  props: {
    meta: {
      type: Object,
      required: false,
      default: null,
    },
    liveSearch: {
      type: Boolean,
      required: false,
      default: false,
    },
    query: {
      type: String,
      required: false,
      default: null,
    },
    showFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
    localStorageKey: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    ListSearch,
  },
  methods: {
    handleSearch(input) {
      this.$emit('search', input);
    },
    handleClearSearch() {
      this.$emit('clearSearch');
    },
  },
};
</script>

<style lang="scss">
@import "~styles/theme/colors";

.nuttrema-list-control {
  background-color: #fff;
  align-self: stretch;
}

.nav--nuttrema-list-control {
  flex-grow: 1;
  display: flex;
  align-self: stretch;
  justify-content: space-between;
  border-bottom: 2px solid $tabs-border-bottom-color;

  .nav-left, .nav-center, .nav-right {
    flex: 1 1 33.33%;
  }

  .nav-center {
    justify-content: flex-start;
  }

  .nav-item {
    color: $gray;
    padding: 0.5em 0.785em;

    .nav-item--label {
      margin-right: 1em;
    }

    .nav-item--title {
      font-weight: 600;
      text-transform: uppercase;
    }

    .nav-item--sup-title {
      font-weight: 500;
      text-transform: uppercase;
      font-size: 0.7rem;
    }

    > i {
      margin-right: 0.5em;
    }

    &.is-with-sup {
      flex-flow: column;
      align-items: flex-start;
      .nav-item--title, .nav-item--sup-title {
        line-height: 1;
      }
      .nav-item--sup-title {
        color: $gray-light;
        margin-bottom: 0.25em;
      }
    }
  }

  .nuttrema-theme-professional-topography & {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-list-control.vue